import { LOGIN_METHODS } from './constants'

const filterLoginData = (data, loginMethod) => {
  const { email, phoneNumber, countryCode, channel, ...rest } = data

  if (loginMethod === LOGIN_METHODS.email) {
    return { email, ...rest }
  }

  if (loginMethod === LOGIN_METHODS.phone_number) {
    return { phoneNumber, countryCode, channel, ...rest }
  }

  throw new Error('Invalid login method')
}

export { filterLoginData }
